<app-header-one [class]="'header-gym'"></app-header-one>
<section class="pt-0 cardpay-page">
  <div class="container">
    <div class="row">
      <div class="col-xl-3 col-lg-3 col-md-3">
        <h2 class="my-5 d-none d-md-block">Il tuo ordine</h2>
        <div class="mt-4 d-block d-md-none"><app-navigation-bar [page]="'Checkout'"></app-navigation-bar></div>
      </div>
      <div class="col-xl-9 col-lg-9 col-md-9 mt-5">

        <div class="row mt-5">
          <div class="col-xl-6 col-12">
            <div class="checkout-page">
              <div class="checkout-title m-0">
                <h3>Pagamento con carta di credito</h3>
              </div>
              <div class="checkout-form py-3">
                <p class="text-start p-title my-3">Inserisci i dati della tua carta</p>
                <form>
                  <div class="row check-out">
                    <div class="col-md-12 col-sm-12 col-xs-12">

                      <div class="media border-product">

                        <!--<img
                          *ngIf="cardForm.controls.buyername.touched && cardForm.controls.buyername.errors?.required"
                          class="img-fluid w-auto p-3 mr-1" src="https://assets.eatintime.it/imgs/info-small.png" alt="">-->

                        <div class="media-body align-self-center ">

                          <input type="text" name="buyername" [formControl]="cardForm.controls['buyername']" value=""
                            autocomplete="off" placeholder="Titolare della carta">

                          <div
                            *ngIf="cardForm.controls.buyername.touched && cardForm.controls.buyername.errors?.required"
                            class="text text-danger d-inline-block">
                            Titolare richiesto.
                          </div>

                        </div>

                      </div>
                    </div>
                  </div>

                  <div class="row check-out">
                    <div class="col-md-12 col-sm-12 col-xs-12">

                      <div class="media border-product">

                        <!--<img *ngIf="cardForm.controls.number.touched && cardForm.controls.number.errors?.required"
                          class="img-fluid w-auto p-3 mr-1" src="https://assets.eatintime.it/imgs/info-small.png" alt="">-->

                        <div class="media-body align-self-center ">

                          <input type="text" name="number" [formControl]="cardForm.controls['number']" value=""
                            autocomplete="off" placeholder="Numero carta">

                          <div *ngIf="cardForm.controls.number.touched && cardForm.controls.number.errors?.required"
                            class="text text-danger d-inline-block">
                            Numero della carta richiesto.
                          </div>

                        </div>

                      </div>
                    </div>
                  </div>

                  <div class="row check-out">

                    <div class="form-group col-md-3 col-sm-3 col-xs-3 ">
                      <div class="media border-product">
                        <!--<img
                          *ngIf="cardForm.controls.expMonth.touched && cardForm.controls.expMonth.errors?.required"
                          class="img-fluid w-auto p-3 mr-1" src="https://assets.eatintime.it/imgs/info-small.png" alt="">-->

                        <div class="media-body align-self-center ">
                          <select [formControl]="cardForm.controls['expMonth']">
                            <option value="" disabled selected class="eit-text-color-grey">Mese</option>
                            <option value="01">01</option>
                            <option value="02">02</option>
                            <option value="03">03</option>
                            <option value="04">04</option>
                            <option value="05">05</option>
                            <option value="06">06</option>
                            <option value="07">07</option>
                            <option value="08">08</option>
                            <option value="09">09</option>
                            <option value="10">10</option>
                            <option value="11">11</option>
                            <option value="12">12</option>
                          </select>
                          <div
                            *ngIf="cardForm.controls.expMonth.touched && cardForm.controls.expMonth.errors?.required"
                            class="text text-danger d-inline-block">
                            Seleziona mese di scadenza
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-group col-md-3 col-sm-3 col-xs-3 ">
                      <div class="media border-product">
                        <!--<img *ngIf="cardForm.controls.expYear.touched && cardForm.controls.expYear.errors?.required"
                          class="img-fluid w-auto p-3 mr-1" src="https://assets.eatintime.it/imgs/info-small.png" alt="">-->

                        <div class="media-body align-self-center ">
                          <select [formControl]="cardForm.controls['expYear']">
                            <option value="" disabled selected class="eit-text-color-grey">Anno</option>
                            <option value="20">2020</option>
                            <option value="21">2021</option>
                            <option value="22">2022</option>
                            <option value="23">2023</option>
                            <option value="24">2024</option>
                            <option value="25">2025</option>
                            <option value="26">2026</option>
                            <option value="27">2027</option>
                            <option value="28">2028</option>
                            <option value="29">2029</option>
                            <option value="30">2030</option>
                            <option value="31">2031</option>
                          </select>
                          <div
                            *ngIf="cardForm.controls.expYear.touched && cardForm.controls.expYear.errors?.required"
                            class="text text-danger d-inline-block">
                            Seleziona anno di scadenza
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-group col-md-6 col-sm-6 col-xs-12 ">
                      <div class="media border-product">
                        <!--<img *ngIf="cardForm.controls.CVV.touched && cardForm.controls.CVV.errors?.required"
                          class="img-fluid w-auto p-3 mr-1" src="https://assets.eatintime.it/imgs/info-small.png" alt="">-->

                        <div class="media-body align-self-center ">
                          <input type="text" name="CVV" [formControl]="cardForm.controls['CVV']" value=""
                            placeholder="" autocomplete="off" placeholder="CVV">
                          <div *ngIf="cardForm.controls.CVV.touched && cardForm.controls.CVV.errors?.required"
                            class="text text-danger d-inline-block">
                            CVV richiesto.
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </form>
                <div class="row my-5">
                  <div class="col-12 d-flex justify-content-between btn-mlt-group">
                    <button class="button-primary-text prev-btn" (click)="goToPay()">
                      <img src="assets/icons/freccia.svg">
                      Torna ai pagamenti
                    </button>
                    <button class="button-primary-text button-fill-rounded" (click)="closeOrder()">
                      Conferma ordine
                      <img src="assets/icons/freccia.svg">
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-6 col-12 d-none d-md-block">
            <app-cart-box [editable]="false" [loader]="false" [showCoupon]="false" [showProducts]="false">
            </app-cart-box>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="row m-0 mt-4 d-none d-sm-block">
      <div class="offset-lg-2 col-lg-8 col-sm-12 col-xs-12 text-center">
        <div class="row m-0 margin-cls">
          <div class="col-12 text-center">
            <button class="btn btn-solid btn-sm btn-block btn-bg-light mx-auto text-center ng-star-inserted text-center"
            (click)="goToPay()">Torna ai pagamenti</button>
          </div>
        </div>
      </div>
    </div> -->
    
  </div>
</section>

<!-- <div class="mobile-fix-option	d-block d-sm-none mobile-footer-fixed text-center">
  <button class="btn btn-solid btn-block btn-sm btn-bg-light mx-auto text-center ng-star-inserted text-center" (click)="goToPay()">Torna ai
    pagamenti</button>
</div> -->
<!-- <section class="total-section fixed-b py-4 px-3 d-block d-md-none" *ngIf="cartData">
  <div class="media mx-3 d-flex justify-content-between" *ngIf="cartData.order.type_order == typeOrder.REST_DOMICILIO || cartData.order.type_order == typeOrder.REST_DOMICILIO">
    <div class="media-body align-self-top">
      <p class="product-title m-0 total-title text-start">Totale</p>
    </div>
    <p class="align-self-top m-0 text-end product-title total-title fw-bold" *ngIf="!cartData.order.ismultiorder">
      {{cartData.order.euro_total.toFixed(2)}} &euro;
    </p>
    <p class="align-self-top m-0 text-end product-title total-title fw-bold" *ngIf="cartData.order.ismultiorder">
      {{cartData.order.eurocarttotal.toFixed(2)}} &euro;
    </p>
  </div>

  <div class="media mx-3 d-flex justify-content-between" *ngIf="cartData.order.type_order == typeOrder.REST_ASPORTO">
    <div class="media-body align-self-top">
      <p class="product-title m-0 total-title text-start">Totale</p>
    </div>

    <p class="align-self-top m-0 text-end product-title total-title fw-bold" *ngIf="!cartData.order.ismultiorder">
      {{cartData.order.euro_total.toFixed(2)}} &euro;
    </p>
    <p class="align-self-top m-0 text-end product-title total-title fw-bold" *ngIf="cartData.order.ismultiorder">
      {{cartData.order.eurocarttotal.toFixed(2)}} &euro;
    </p>
  </div>
</section> -->
<section class="total-section py-4 px-3 d-block d-md-none" *ngIf="cartData">
  <div class="media mx-3 d-flex justify-content-between" *ngIf="cartData.order.type_order == typeOrder.REST_DOMICILIO || cartData.order.type_order == typeOrder.REST_DOMICILIO">
    <div class="media-body align-self-top">
      <p class="product-title m-0 total-title text-start">Totale</p>
    </div>
    <p class="align-self-top m-0 text-end product-title total-title fw-bold" *ngIf="!cartData.order.ismultiorder">
      {{cartData.order.euro_total.toFixed(2)}} &euro;
    </p>
    <p class="align-self-top m-0 text-end product-title total-title fw-bold" *ngIf="cartData.order.ismultiorder">
      {{cartData.order.eurocarttotal.toFixed(2)}} &euro;
    </p>
  </div>

  <div class="media mx-3 d-flex justify-content-between" *ngIf="cartData.order.type_order == typeOrder.REST_ASPORTO">
    <div class="media-body align-self-top">
      <p class="product-title m-0 total-title text-start">Totale</p>
    </div>

    <p class="align-self-top m-0 text-end product-title total-title fw-bold" *ngIf="!cartData.order.ismultiorder">
      {{cartData.order.euro_total.toFixed(2)}} &euro;
    </p>
    <p class="align-self-top m-0 text-end product-title total-title fw-bold" *ngIf="cartData.order.ismultiorder">
      {{cartData.order.eurocarttotal.toFixed(2)}} &euro;
    </p>
  </div>
</section>
<app-footer-two [class]="'bg-img-gym bg-size'"></app-footer-two>